import {useFormState} from 'react-final-form';
import {useIsShowMap} from './useIsShowMap';

export default function useFieldRules(fieldName) {
    const {values} = useFormState();
    const isVisibleMap = useIsShowMap(values);

    return {
        isVisible: !!isVisibleMap[fieldName],
    };
}
